/*
 * @Description: 业务办理模块
 * @FilePath: /netHallOfficialAccounts/src/router/business.js
 */

//业务办理
const BusinessStep = () => import('@/views/Business/components/BusinessStep');
const Expand = () => import('@/views/Business/Expand');
const InstallWater = () => import('@/views/Business/Expand/InstallWater');
const RenamedNotice = () => import('@/views/Business/Renamed');
const WaterRenamed = () => import('@/views/Business/Renamed/WaterRenamed');
const NewsTurnNotice = () => import('@/views/Business/NewsTurn');
const WaterNewsTurn = () => import('@/views/Business/NewsTurn/WaterNewsTurn');
const PersonInstall = () => import('@/views/Business/PersonInstall');
const PersonInstallFrom = () => import('@/views/Business/PersonInstall/PersonInstall');

const businessRouter = [
  //业务办理
  {
    path: '/Business/BusinessStep',
    name: 'BusinessStep',
    component: BusinessStep,
    meta: {
      title: '办理进度',
    },
  },
  {
    path: '/Business/Expand',
    name: 'Expand',
    component: Expand,
    meta: {
      title: '新户开通须知',
    },
  },
  {
    path: '/Expand/InstallWater',
    name: 'InstallWater',
    component: InstallWater,
    meta: {
      title: '新户开通',
    },
  },
 {
    path: '/Business/PersonInstall',
    name: 'PersonInstall',
    component: PersonInstall,
    meta: {
      title: '自主开户须知',
    },
  },
  {
    path: '/PersonInstall/PersonInstall',
    name: 'PersonInstallFrom',
    component: PersonInstallFrom,
    meta: {
      title: '自主开户',
    },
  },
  {
    path: '/Business/RenamedNotice',
    name: 'RenamedNotice',
    component: RenamedNotice,
    meta: {
      title: '更名须知',
    },
  },
  {
    path: '/Business/WaterRenamed',
    name: 'WaterRenamed',
    component: WaterRenamed,
    meta: {
      title: '更名',
    },
  },
  {
    path: '/Business/NewsTurnNotice',
    name: 'NewsTurnNotice',
    component: NewsTurnNotice,
    meta: {
      title: '变更手机号码须知',
    },
  },
  {
    path: '/Business/WaterNewsTurn',
    name: 'WaterNewsTurn',
    component: WaterNewsTurn,
    meta: {
      title: '变更手机号码',
    },
  },
];

export default businessRouter;
